<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        Stock taking records
        <v-spacer></v-spacer>
        <v-btn
          text
          class="mr-2"
          x-large
          depressed
          rounded
          @click="getItems"
          :loading="loading"
          >Reload</v-btn
        >
        <v-btn
          @click="showNewDialog = true"
          color="orange"
          dark
          rounded
          depressed
          x-large
          >Create New</v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-skeleton-loader type="table" v-if="loading"></v-skeleton-loader>
        <v-simple-table
          fixed-header
          height="80vh"
          v-else-if="items && items.data.length > 0"
        >
          <thead>
            <tr>
              <th>Description</th>
              <th>Item count</th>
              <th>Status</th>

              <th>Created By</th>
              <th>Created At</th>
              <th>Updated At</th>

              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items.data" :key="item.id">
              <td>{{ item.description }}</td>
              <td>
                Total:{{ item.items_count }}<br />
                Recorded:{{ item.recorded_items }}
                <v-progress-linear
                  color="green"
                  :value="
                    item.items_count > 0
                      ? (item.recorded_items / item.items_count) * 100
                      : 0
                  "
                ></v-progress-linear>
                Remaining:{{ item.not_recorded_items }}
                <v-progress-linear
                  color="red"
                  class="mb-2"
                  :value="
                    item.items_count > 0
                      ? (item.not_recorded_items / item.items_count) * 100
                      : 0
                  "
                ></v-progress-linear>
              </td>
              <td :class="{ 'red--text': item.locked }">
                {{ item.locked ? "Locked" : "Open" }}
                <v-icon small :color="item.locked ? 'red' : 'grey'">
                  {{
                    item.locked ? "mdi-lock-outline" : "mdi-lock-open-outline"
                  }}
                </v-icon>
              </td>
              <td>
                {{ item.user_name }}
              </td>
              <td>
                {{ item.created_at | humanDateTime }}
              </td>

              <td>
                {{ item.updated_at | humanDateTime }}
              </td>
              <td>
                <v-btn
                  class="pa-1"
                  @click="
                    selectedItem = item;
                    showItemDetails = true;
                  "
                  text
                  color="orange"
                  rounded
                  x-large
                  depressed
                >
                  View Details
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <norecords-component
          v-else
          title="No Stock Taking Records Yet"
          description="History of your stock taking will show here, create a new record by clicking on the create new button "
        ></norecords-component>
      </v-card-text>
      <v-card-actions v-if="items">
        <pagination-component
          :links="items.links"
          @goto="(page) => getItems(page)"
        ></pagination-component>
      </v-card-actions>
    </v-card>

    <v-dialog
      scrollable
      persistent
      fullscreen
      v-model="showNewDialog"
      transition="dialog-bottom-transition"
    >
      <new-stock-taking-component
        @deleted="
          showItemDetails = false;
          getItems();
        "
        @closed="showNewDialog = false"
      ></new-stock-taking-component>
    </v-dialog>

    <v-dialog
      scrollable
      persistent
      fullscreen
      v-model="showItemDetails"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title
          >Stock taking record details
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDetailsDialog"
            depressed
            rounded
            small
            color="red lighten-5 red--text"
            >Close
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <stock-taking-item-details-component
          @deleted="
            showItemDetails = false;
            getItems();
          "
          @updated="(item) => (selectedItem = item)"
          :item="selectedItem"
          v-if="selectedItem"
        ></stock-taking-item-details-component>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewStockTakingComponent from "./NewStockTakingComponent.vue";
import StockTakingItemDetailsComponent from "./StockTakingItemDetailsComponent.vue";
import PaginationComponent from "./PaginationComponent.vue";
import NorecordsComponent from "./noRecordComponent.vue";

export default {
  name: "StockTakingComponent",
  components: {
    NorecordsComponent,
    PaginationComponent,
    StockTakingItemDetailsComponent,
    NewStockTakingComponent,
  },
  data() {
    return {
      showNewDialog: false,
      items: null,
      loading: false,
      showItemDetails: false,
      selectedItem: null,
    };
  },
  computed: {
    URLUUID() {
      return this.$route.query.item_id;
    },
  },
  watch: {
    URLUUID() {
      if (this.URLUUID) {
        this.getItem(this.URLUUID);
      }
    },
  },
  methods: {
    closeDetailsDialog() {
      this.$router.replace({ item_id: null });
      this.showItemDetails = false;
    },
    getItem(uuid) {
      this.loading = true;

      const URL = "/api/stock-taking/" + uuid;
      axios.get(URL).then((res) => {
        this.selectedItem = res.data;
        this.showItemDetails = true;
        this.loading = false;
      });
    },

    getItems(page = 1) {
      this.loading = true;

      const URL = "/api/stock-taking?page=" + page;

      axios.get(URL).then((res) => {
        this.items = res.data;
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getItems();

    if (this.URLUUID) {
      this.getItem(this.URLUUID);
    }
  },
};
</script>
